// client/src/hooks/useClientPortalAuth.js
// Deliberately separate from hooks/useAuth.js: its own localStorage key, its own login
// endpoint, no shared state with the staff/agent auth system.
import React, { useCallback } from 'react';

const TOKEN_KEY = 'clientPortalToken';

export const useClientPortalAuth = () => {
    const [token, setToken] = React.useState(localStorage.getItem(TOKEN_KEY));
    const [error, setError] = React.useState('');
    const [loading, setLoading] = React.useState(false);

    const logout = useCallback(() => {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem('clientPortalKind');
        setToken(null);
        window.location.href = '/client-portal/login';
    }, []);

    const login = async (login_email, password) => {
        setLoading(true);
        setError('');
        try {
            const response = await fetch('/api/client-portal/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ login_email, password }),
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.message || 'Login failed');
            localStorage.setItem(TOKEN_KEY, data.token);
            // 'visitor' = registered on the website (property features only); the server
            // re-checks on every request, this only picks the landing page and menu.
            localStorage.setItem('clientPortalKind', data.accountKind || 'client');
            setToken(data.token);
            return { mustChangePassword: !!data.mustChangePassword, accountKind: data.accountKind || 'client' };
        } catch (err) {
            setError(err.message);
            return null;
        } finally {
            setLoading(false);
        }
    };

    return { token, login, logout, error, loading };
};
